<div class="app">

  @if (showChrome()) {
    <app-sidebar-component
        [items]="sidebarItems()"
        [isOpen]="sidebarOpen()"
        [collapsed]="sidebarCollapsed()"
        [activeId]="activeSidebarId()"
        [activeChildId]="activeSidebarChildId()"
        [role]="sidebarRole()"
        [logoUrl]="sidebarLogoUrl()"
        [logoLoading]="sidebarLogoPending()"
        (openChange)="onSidebarOpenChange($event)"
        (menuToggle)="onMenuToggle()"
        (navigate)="onSidebarNavigate($event)">
    </app-sidebar-component>
  }

  <div class="app__main">

    @if (showChrome()) {
      <app-top-bar-component
          [sidebarCollapsed]="sidebarCollapsed()"
          (menuToggle)="onMenuToggle()"
          (searchSubmit)="onHeaderSearch($event)"
          (clearSearch)="onHeaderClearSearch()"
          (resultSelect)="onSearchResultSelect($event)"
          (action)="onTopBarAction($event)">
      </app-top-bar-component>

      <app-breadcrumb-bar-component
          [label]="pageLabel() | translate"
          [segments]="breadcrumbs()"
          (back)="goBack()"
          (navigate)="goToCrumb($event)"
          (home)="goHome()">
        <!-- Term-scope selector (2026-08-19 ADR D1/D6): mounted only while a page
             (Workspace / Reports) has registered its handle with TermScopeService.
             `[value]`/`(valueChange)` bind the page's LIVE term signal directly through
             the handle, so the control reflects — and instantly drives — that page's
             scope without chrome owning any domain state of its own. -->
        @if (termScope.handle(); as h) {
          <div bcTrailing class="app__breadcrumb-term">
            <app-term-scope-selector [value]="h.term()" (valueChange)="h.setTerm($event)" />
          </div>
        }
      </app-breadcrumb-bar-component>
    }

    <div class="app__content">
      <router-outlet></router-outlet>

      @if (showChrome()) {
        <!-- Customer logo in the sidebar → "Powered by RegTrack™"; RegTrack logo →
             plain copyright line (the brand is already on screen). -->
        <footer class="page-footer">
          <div class="page-footer__left">
            @if (hasCustomerLogo) {
              <span>{{ 'footer.poweredBy' | translate }}</span>
              <img class="page-footer__logo" [src]="footerRegtrackLogoUrl"
                   [alt]="'footer.regtrackLogoAlt' | translate" width="74" height="14">
            } @else {
              <span>{{ 'footer.copyright' | translate: { year: footerYear } }}</span>
            }
            <span aria-hidden="true">·</span>
            <span>{{ productVersion }}</span>
          </div>
          <div class="page-footer__links">
            <a [href]="footerPrivacyPolicyUrl" target="_blank" rel="noopener noreferrer">{{ 'footer.privacyPolicy' | translate }}</a>
            <a [href]="footerTermsOfUseUrl" target="_blank" rel="noopener noreferrer">{{ 'footer.termsOfUse' | translate }}</a>
          </div>
        </footer>
      }
    </div>

  </div>
</div>

<app-idle-timeout-warning />
